import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalComponent } from '../../global-component';
import { CurrentUser } from '../models/currentuser.models';
import { Observable } from 'rxjs';
import { TokenStorageService } from './token-storage.service';
import { DesignPlacard } from '../models/designplacards.models';

const BASE_URL = GlobalComponent.BASE_API_URL;
@Injectable({ providedIn: 'root' })

/**
 * Planset-service Component
 */
export class PlacardService {

    currentuser!: CurrentUser;

    constructor(private http: HttpClient, private tokenService: TokenStorageService) {
        this.currentuser = this.tokenService.getCurrentUser();
    }

    //FETCH PLACARDS 
    getAllPlacards(postdata : any) : Observable<any[]> {
        return this.http.post<any[]>(BASE_URL + "designplacard/designplacard", {
            data : postdata
        });
    }

    //ADD PLACARD RECORD
    createPlacard(postdata: any) : Observable<any[]> {
        // return this.http.post(BASE_URL + "designplacards?filters[status][$eq]=true&sort[0]=updatedAt:DESC", { });
        return this.http.post<any>(BASE_URL + 'designplacards', {
            data: postdata
          });
    }

     //UPDATE PLACARD RECORD
     updatePlacard(postdata: any, id: number) : Observable<any[]> {
        // return this.http.post(BASE_URL + "designplacards?filters[status][$eq]=true&sort[0]=updatedAt:DESC", { });
        return this.http.put<any>(BASE_URL + 'designplacards/' + id, {
            data: postdata
          });
    }
}